import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit
} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatFormField} from '@angular/material/form-field';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CriterionService, IndexEntityService, ReferenceService} from '../../../apiModule1';
import {AsyncPipe, NgClass, NgStyle} from '@angular/common';
import {MatLabel, MatSelect} from '@angular/material/select';
import {MatInput} from '@angular/material/input';
import {map} from 'rxjs/operators';
import {BehaviorSubject, Observable, of, switchMap, tap} from 'rxjs';
import {MultiSelectComponent} from '../../../../shared/components/multi-select/multi-select.component';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {mapToCanActivate} from '@angular/router';

@Component({
  selector: 'pas-filter-dialog-criterion',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatFormField,
    MatAutocomplete,
    MatOption,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatFormField,
    MatLabel,
    AsyncPipe,
    MatSelect,
    MatInput,
    MatButton,
    NgClass,
    NgStyle,
    MatDialogClose,
    MultiSelectComponent,
    MultiSelect2Component
  ],
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss','../../index-entity/filter-dialog/filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDialogComponent implements OnInit{
  dialogRef = inject(MatDialogRef<FilterDialogComponent>);
  referenceService = inject(ReferenceService);
  data: Record<string, any> = inject(MAT_DIALOG_DATA)
  criterionService = inject(CriterionService);

  archiveStatuses: Status[] = []
  filteredIndexes: Observable<IndexEntry[]> = of([])
  dataCriterions: Criterion[] = []

  get filteresCriterionsMaped(): Observable<string[]> {
    return this.filteredIndexes.pipe(map(v => v.map(i => i.name)))
  }

  get dataCriterionsNames(): string[] {
    return this.dataCriterions.map(v => v.name);
  }

  private selectedIndex?: IndexEntry;

  get archiveStatusesNames(): string[] {
    return this.archiveStatuses.map(v => v.name);
  }

  isAutocompleteOpen: boolean = false;
  isAutocompleteOpen1: boolean = false;
  isAutocompleteOpen2: boolean = false;

  periods: CriterionPeriod[] = []


  form = new FormGroup({
    archive: new FormControl(),
    criterion: new FormControl(),
    period: new FormControl(),
  })

  dataFromIndexControl$ = new BehaviorSubject<string>(''); //для генерации новых запросов при вводе запроса в input

  onNoClick(): void {
    this.dialogRef.close();
  }


  ngOnInit(): void {
    console.log('filter-dialog data', this.data);

    this.referenceService.apiReferencePeriodsGet().pipe(map(v => v.values)).subscribe((v: CriterionPeriod[]) => {
      this.periods = v;
    })

    this.dataFromIndexControl$
      .pipe(switchMap((v: string) =>
        this.criterionService.apiCriterionFilterlistGet({filteredObjectName: 'criterion', searchString: v})
          .pipe(map(v => v?.values))
      )).subscribe(v => {
      this.dataCriterions = v;
    })

    //задаем начальные значения для контролов приходящие в data
    this.data && this.data['criterionIds'] && this.form.get('criterion')!.setValue(this.data['criterionIds'], {emitEvent: false});
    this.data && this.data['periodIds'] && this.form.get('period')!.setValue(this.data['periodIds'], {emitEvent: false});
    this.data && this.data['statusIds'] && this.form.get('archive')!.setValue(this.data['statusIds'], {emitEvent: false});

    this.referenceService.apiReferenceStatusesGet().pipe(map(v => v.values)).subscribe((v: Status[]) => {
      this.archiveStatuses = v;
      const statusIdFromData = this.data && this.data['statusId'];
      const statusSelect = this.archiveStatuses.find(s => s.id === +(statusIdFromData))?.name;
      this.form.get('archive')!.setValue(statusSelect);
    })

  }

  onReset(): void {
    this.form.reset();
  }

  onApply() {

    const res = {
      statusIds: this.form.get('archive')!.value,
      criterionIds: this.form.get('criterion')!.value,
      periodIds: this.form.get('period')!.value
    }

    this.dialogRef.close(res);
  }


  onInputIndexChange(event: string): void {
    this.dataFromIndexControl$.next(event);
  }

  protected readonly mapToCanActivate = mapToCanActivate;


}
